/* jshint esversion: 6, -W097 */
/* globals require */
'use strict';


function rangeNumberFilterDirective() {
    return {
        restrict: 'E',
        scope: {
            code: '=',
            options: '=',
            isButtonEnabled: '=',
            hasTitle: '=',
            isFullWidth: '=',
            isFilterDropdownOpen: '=',
            isCurrency: '=',
            trigger: '='
        },
        controllerAs: 'vm',
        bindToController: true,
        controller: rangeNumberFilter,
        template: require('./rangeNumberFilterView.html')
    };
}

rangeNumberFilter.$inject = [
    '$filter',
    'FiltersService',
    'UtilService',
];
function rangeNumberFilter(
    $filter,
    FiltersService,
    UtilService
) {

    this.$onInit = () => {
        const vm = this;

        vm.showDesktopFilterSearchButton = !UtilService.isMobile() && FiltersService.isNewFiltersEnabled;

        prePopulate();

        vm.isReady = () => {
            return !FiltersService.lockFilters;
        };

        vm.rangeValueChanged = rangeValueChanged;

        /**
         * While the range values are changing, we want to update the results quantity based on the latest state of the filters
         *
         */
        vm.valueChanging = () => {
            FiltersService.trackProductFiltersEngaged(filterOutput());
            if (FiltersService.isNewFiltersEnabled && UtilService.isMobile()) {
                FiltersService.getResultsOnChange();
            }
        };

        FiltersService.filtersOutputCallbacks.push({
            'filter_output': filterOutput
        });

        FiltersService.filtersResetCallbacks.push({
            filterKey: vm.code,
            callback: filterReset
        });

        /**
         * Pre-populates the filter
         *
         */
        function prePopulate() {
            vm.left = {
                placeholder: vm.options.values[0].min_value,
                code: 'min_' + vm.code,
                value: null,
                initialValue: null
            };
            vm.right = {
                placeholder: vm.options.values[0].max_value,
                code: 'max_' + vm.code,
                value: null,
                initialValue: null
            };
            vm.units = vm.options.units;

            if (vm.isCurrency) {
                vm.left.placeholder = $filter('toCurrency')(vm.left.placeholder);
                vm.right.placeholder = $filter('toCurrency')(vm.right.placeholder);
            }

            if (vm.code in FiltersService.initialFiltersData) {
                vm.left.value = parseFloat(FiltersService.initialFiltersData[vm.code].from) || null;
                vm.left.initialValue = parseFloat(FiltersService.initialFiltersData[vm.code].from) || null;
                vm.right.value = parseFloat(FiltersService.initialFiltersData[vm.code].to) || null;
                vm.right.initialValue = parseFloat(FiltersService.initialFiltersData[vm.code].to) || null;
            }
        }

        /**
         * Processes range value change functionality
         */
        function rangeValueChanged() {
            if (vm.left.value === vm.left.initialValue && vm.right.value === vm.right.initialValue) {
                // nothing changed. don't fire.
                return;
            }
            FiltersService.getResultsOnChange();
        }

        /**
         * Outputs the filter's user inputs in form of a single-level key values dictionary
         *
         * Empty filter whose `value` is `null` is still passed to FilterService so that
         * `FilterService.allFiltersOutputsJson` can be overwritten with
         * `null` values to handle cases where a user removes a previously applied filter value
         *
         * @returns {'filter_code', 'filter_value'}
         */
        function filterOutput () {
            let output = {};

            if (!FiltersService.isNewFiltersEnabled) {
                // this is a top filter, but the dropdown is open, so ignore this.
                if (vm.isFilterDropdownOpen && vm.trigger) {
                    return output;
                }

                // this is a menu filter but the top filter is changed, so ignore this.
                if (!vm.isFilterDropdownOpen && !vm.trigger) {
                    return output;
                }
            }

            output[vm.options.url_value] = {type: 'range'};
            if (vm.left.value === null && vm.right.value === null) {
                output[vm.options.url_value] = null;
            } else {
                if (vm.left.value) {
                    output[vm.options.url_value].min = vm.left.value;
                }
                if (vm.right.value) {
                    output[vm.options.url_value].max = vm.right.value;
                }
            }
            return output;
        }

        /**
         * Resets this filter
         */
        function filterReset () {
            vm.left.value = null;
            vm.right.value = null;
        }
    };
}

module.exports = rangeNumberFilterDirective;
